// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/**
 * Helpers for reading raw player payloads. Player endpoints are hand-written anonymous objects on
 * the server and a few older routes still emit PascalCase, so both casings are accepted.
 */

const readString = (player: Record<string, unknown>, ...keys: string[]): string | null => {
  for (const key of keys) {
    const value = player[key];
    if (typeof value === 'string' && value.trim().length > 0) {
      return value.trim();
    }
  }
  return null;
};

/** The user who created this player, set only for guests. Null for registered players. */
export const readCreatedByUserId = (player: Record<string, unknown>): string | null =>
  readString(player, 'createdByUserId', 'CreatedByUserId');

/**
 * True when the given user created this player — i.e. it is one of "my players", a guest they added
 * earlier. Registered players are never "mine": they belong to their own account.
 */
export const isCreatedByCurrentUser = (
  player: Record<string, unknown>,
  currentUserId: string | null | undefined
): boolean => {
  if (!currentUserId) {
    return false;
  }
  return readCreatedByUserId(player) === currentUserId;
};
